module.exports = __webpack_public_path__ + "static/media/yipo.badc8213.png";